import React, { useEffect } from 'react';
import { Box, Container, Grid, Typography, Button, Card, CardContent, Avatar, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ShareIcon from '@mui/icons-material/Share';
import FavoriteIcon from '@mui/icons-material/Favorite';
import CommentIcon from '@mui/icons-material/Comment';
import { Helmet } from 'react-helmet-async';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

export default function InfluencerMarketingSection() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const features = [
    {
      title: "Influencer Selection",
      description: "Find the perfect influencers who align with your brand values and target audience.",
      icon: "🎯",
      likes: "3.2K",
      comments: "245"
    },
    {
      title: "Campaign Strategy",
      description: "Develop effective influencer marketing campaigns that drive engagement and results.",
      icon: "📊",
      likes: "2.9K",
      comments: "198"
    },
    {
      title: "Content Creation",
      description: "Collaborate with influencers to create authentic, engaging content for your brand.",
      icon: "📱",
      likes: "3.4K",
      comments: "256"
    },
    {
      title: "Performance Tracking",
      description: "Monitor and analyze campaign performance to optimize your influencer marketing efforts.",
      icon: "📈",
      likes: "2.8K",
      comments: "187"
    }
  ];

  const benefits = [
    "Increased brand awareness",
    "Higher engagement rates",
    "Authentic brand promotion",
    "Targeted audience reach",
    "Better ROI",
    "Enhanced credibility"
  ];

  return (
    <>
    
<Box
  sx={{
    position: 'fixed',
    top: { xs: 50, sm: 70 },
    left: { xs: 12, sm: 24 },
    zIndex: 1200,
    bgcolor: 'white',
    borderRadius: '50%',
    boxShadow:5,
    width: { xs: 40, sm: 48 },
    height: { xs: 40, sm: 48 },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }}
>
  <IconButton
    onClick={() => navigate(-1)}
    size="medium"
    sx={{
      color: '#1877f2',
      p: 0.5
    }}
  >
    <ArrowBackIosNewIcon fontSize="small" />
  </IconButton>
</Box>
    <Helmet>
        <title>Influencer Marketing Services in Visakhapatnam | SLGT Digital Marketing</title>
        <meta
          name="description"
          content="Get top influencer marketing services in Visakhapatnam. SLGT helps brands collaborate with nano, micro, macro & celebrity influencers for real engagement and ROI-driven campaigns."
        />
        <meta
          name="keywords"
          content="best digital marketing,Influencer Marketing Visakhapatnam, Influencer Agency Vizag, Nano Influencers, Micro Influencers, Celebrity Influencer Campaigns, Social Media Influencer Marketing"
        />
        <link rel="canonical" href="https://www.slgt.in/services/influencer-marketing" />
      </Helmet>
    <Box sx={{ 
      pt: { xs: 8, sm: 10 },
      pb: { xs: 6, sm: 8 },
      minHeight: '100vh',
      bgcolor: '#f0f2f5'
    }}>
      {/* Hero Section */}
      <Box 
        sx={{ 
          bgcolor: '#ffffff',
          color: '#1c1e21',
          py: { xs: 6, md: 8 },
          mb: { xs: 4, md: 6 },
          boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <Avatar 
                  sx={{ 
                    width: 56, 
                    height: 56, 
                    mr: 2,
                    bgcolor: '#1877f2'
                  }}
                >
                  IM
                </Avatar>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                      color: '#1c1e21'
                    }}
                  >
                    Influencer Marketing
                  </Typography>
                  <Typography
                    sx={{
                      color: '#65676b',
                      fontSize: '0.9rem',
                      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
                    }}
                  >
                    Professional Influencer Services
                  </Typography>
                </Box>
              </Box>
              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                  fontWeight: 700,
                  mb: { xs: 2, md: 3 },
                  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                  color: '#1c1e21',
                  lineHeight: 1.2
                }}
              >
             Influencer Marketing Services in Vishakhapatnam
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: '1rem', sm: '1.1rem' },
                  mb: { xs: 3, md: 4 },
                  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                  color: '#65676b',
                  lineHeight: 1.6
                }}
              >
Tired of choosing influencers, paying them, and seeing no results? We handpick the best influencers—from nano, micro, macro, and celebrity influencers—to ensure genuine engagement, brand growth, and ROI-driven campaigns.              </Typography>
              <Button
                variant="contained"
                onClick={() => navigate('/requestquotes')}
                sx={{
                  bgcolor: '#1877f2',
                  color: 'white',
                  '&:hover': { bgcolor: '#166fe5' },
                  px: { xs: 4, sm: 6 },
                  py: { xs: 1.5, sm: 2 },
                  fontSize: { xs: '1rem', sm: '1.1rem' },
                  fontWeight: 600,
                  borderRadius: '6px',
                  textTransform: 'none'
                }}
              >
                Get Started
              </Button>
            </Grid>
            <Grid item xs={12} md={6} sx={{ display: { xs: 'none', md: 'block' } }}>
              <img
                src="/assets/services/im-1.jpg"
                alt="Influencer Marketing Illustration"
                style={{
                  width: '100%',
                  maxWidth: '500px',
                  height: 'auto',
                  display: 'block',
                  margin: '0 auto',
                  borderRadius: '8px'
                }}
              />
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Features Section */}
      <Container maxWidth="lg" sx={{ mb: { xs: 6, md: 8 } }}>
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '1.75rem', sm: '2rem', md: '2.5rem' },
            fontWeight: 700,
            mb: { xs: 4, md: 6 },
            textAlign: 'center',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
            color: '#1c1e21',
            lineHeight: 1.2
          }}
        >
          Our Influencer Marketing Services
        </Typography>
        <Grid container spacing={3}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Card 
                sx={{ 
                  height: '100%',
                  borderRadius: '8px',
                  boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                  bgcolor: '#ffffff'
                }}
              >
                <CardContent sx={{ p: 0 }}>
                  {/* Post Header */}
                  <Box sx={{ p: 2, borderBottom: '1px solid #e4e6eb' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Avatar sx={{ width: 40, height: 40, mr: 2, bgcolor: '#1877f2' }}>
                        {feature.icon}
                      </Avatar>
                      <Box>
                        <Typography
                          sx={{
                            fontWeight: 600,
                            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                            color: '#1c1e21'
                          }}
                        >
                          {feature.title}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: '0.9rem',
                            color: '#65676b',
                            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
                          }}
                        >
                          Professional Influencer Service
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  {/* Post Content */}
                  <Box sx={{ p: 2 }}>
                    <Typography
                      sx={{
                        color: '#1c1e21',
                        fontSize: '1rem',
                        lineHeight: 1.6,
                        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
                      }}
                    >
                      {feature.description}
                    </Typography>
                  </Box>

                  {/* Post Actions */}
                  <Box sx={{ 
                    p: 1, 
                    borderTop: '1px solid #e4e6eb',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <IconButton size="small" sx={{ color: '#1877f2' }}>
                        <FavoriteIcon />
                      </IconButton>
                      <Typography sx={{ color: '#65676b', fontSize: '0.9rem' }}>
                        {feature.likes}
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <IconButton size="small" sx={{ color: '#65676b' }}>
                        <CommentIcon />
                      </IconButton>
                      <Typography sx={{ color: '#65676b', fontSize: '0.9rem' }}>
                        {feature.comments}
                      </Typography>
                    </Box>
                    <IconButton size="small" sx={{ color: '#65676b' }}>
                      <ShareIcon />
                    </IconButton>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Benefits Section */}
      <Box sx={{ bgcolor: '#ffffff', py: { xs: 6, md: 8 } }}>
        <Container maxWidth="lg">
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '1.75rem', sm: '2rem', md: '2.5rem' },
              fontWeight: 700,
              mb: { xs: 4, md: 6 },
              textAlign: 'center',
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
              color: '#1c1e21',
              lineHeight: 1.2
            }}
          >
            Benefits of Influencer Marketing
          </Typography>
          <Grid container spacing={3}>
            {benefits.map((benefit, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card 
                  sx={{ 
                    height: '100%',
                    borderRadius: '8px',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                    bgcolor: '#ffffff'
                  }}
                >
                  <CardContent sx={{ p: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Avatar 
                        sx={{ 
                          width: 40, 
                          height: 40, 
                          mr: 2,
                          bgcolor: '#1877f2'
                        }}
                      >
                        ✓
                      </Avatar>
                      <Typography
                        sx={{
                          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                          fontSize: '1rem',
                          color: '#1c1e21',
                          fontWeight: 500
                        }}
                      >
                        {benefit}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* CTA Section */}
      <Container maxWidth="lg" sx={{ mt: { xs: 6, md: 8 }, textAlign: 'center' }}>
        <Card 
          sx={{ 
            borderRadius: '8px',
            boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
            bgcolor: '#ffffff',
            p: { xs: 3, md: 4 }
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '1.75rem', sm: '2rem', md: '2.5rem' },
              fontWeight: 700,
              mb: 3,
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
              color: '#1c1e21',
              lineHeight: 1.2
            }}
          >
            Ready to Connect with Influencers?
          </Typography>
          <Typography
            sx={{
              mb: 4,
              fontSize: { xs: '1rem', sm: '1.1rem' },
              maxWidth: '800px',
              mx: 'auto',
              color: '#65676b',
              lineHeight: 1.6,
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
            }}
          >
            Let's create a powerful influencer marketing strategy that helps you reach and engage your target audience.
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate('/requestquotes')}
            sx={{
              bgcolor: '#1877f2',
              color: 'white',
              '&:hover': { bgcolor: '#166fe5' },
              px: { xs: 4, sm: 6 },
              py: { xs: 1.5, sm: 2 },
              fontSize: { xs: '1rem', sm: '1.1rem' },
              fontWeight: 600,
              borderRadius: '6px',
              textTransform: 'none'
            }}
          >
            Request a Quote
          </Button>
        </Card>
      </Container>
    </Box>
  );
  </>  
  );
}
